import React from "react";
import Icon from "./Icon";

interface AdminEmptyStateProps {
  iconType?: string;
  iconName?: string;
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIconType?: string;
  actionIconName?: string;
}

/**
 * Friendly empty-state placeholder (icon circle + title + hint + optional
 * refresh/reset action) used across admin screens.
 */
const AdminEmptyState: React.FC<AdminEmptyStateProps> = ({
  iconType = "MaterialCommunityIcons",
  iconName = "inbox-outline",
  title = "",
  message = "",
  actionLabel,
  onAction,
  actionIconType = "MaterialCommunityIcons",
  actionIconName = "refresh",
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-12 text-center">
      <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-[#FFF3E0]">
        <Icon iconType={iconType} name={iconName} size={36} color="#ffa217" />
      </div>
      {title ? (
        <div className="mb-1.5 text-center text-[17px] font-semibold text-[#333]">
          {title}
        </div>
      ) : null}
      {message ? (
        <div className="mb-5 text-center text-[13px] leading-[19px] text-[#888]">
          {message}
        </div>
      ) : null}
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex items-center gap-1.5 rounded-[10px] bg-[#ffa217] px-5 py-2.5 text-[13px] font-semibold text-white transition hover:opacity-90"
        >
          <Icon
            iconType={actionIconType}
            name={actionIconName}
            size={16}
            color="#fff"
          />
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
};

export default AdminEmptyState;
